<template>
  <div class="ndetails">
    <div class="details litigation-details">
      <a-spin :spinning="loading">
        <div class="maindetails">
          <div class="dislogbox">
            <Book :id="causeId" v-if="dislog.Book"></Book>
            <!-- <FileHistory :List='debInfo.keep' ref='FileHistory' :clear='debInfo.is_clear' v-if='dislog.FileHistory'
              :disabled="true"></FileHistory> -->
          </div>
          <div class="radio-inputs">
            <label class="radio" v-for='(item, index) in caselist' :key='item.id'>
              <button :class="[item.id === selectedIndex ? 'titleButton' : 'selected']"
                @click="switchChange(item, index)">
                {{ item.cause_type == 1 ? `案件 ${item.sort} ( 诉讼 )` : `案件 ${item.sort} ( 仲裁 )` }}
              </button>
            </label>
          </div>
          <div class="card wbg">
            <div class="htit">
              <div class="h2">当事人信息</div>
            </div>
            <Basic class="background" :i="i" :justlook="true" @update-user="handleUpdateUser"></Basic>
          </div>
          <Other ref='Other' :info='OtherInfo' :see="see" :i=i :accuserList='accuserList'></Other>
          <!-- 诉讼费用 -->
          <paymentCard rfe="paymentPopUp" v-if="dislog.paymentPopUp" :showModify='false'></paymentCard>
          <Compensation ref='Compensation' :i='i'></Compensation>
          <!-- <div class="card wbg">
            <img class="clearfa" src="../../assets/img/jqpic_03.png" v-if="debInfo.is_clear == 1" width="132" />
            <div class="htit">
              <div class="h2">被告信息</div>
            </div>
            <div class="nselectbox">
              <a-row type='flex' style="margin-bottom:20px;">
                <a-col :span='3'>
                  <label>姓名：</label>
                  <span>{{ debInfo.realname }}</span>
                </a-col>
                <a-col :span='4'>
                  <label>证件号码：</label>
                  <span style="white-space:normap;">{{ debInfo.chinaid }}</span>
                </a-col>
                <a-col :span='2'>
                  <label>性别：</label>
                  <span>{{ debInfo.sex | tosex }}</span>
                </a-col>
                <a-col :span='4'>
                  <label>联系方式：</label>
                  <span>{{ debInfo.phone }}</span>
                </a-col>
                <a-col :span='3'>
                  <label>业务类型：</label>
                  <span>{{ debInfo.car_type_id | tocarName(APIKEY.carlist) }}</span>
                </a-col>
                <a-col :span="4">
                  <label>诉讼地位准确：</label>
                  <span>{{ debInfo.is_role_exact == 3 ? '混合' : (debInfo.is_role_exact == 1 ? '是' : '否') }}</span>
                </a-col>
                <a-col :span="4">
                  <label>诉讼完毕：</label>
                  <span>{{ debInfo.cause_is_complete == 0 ? '否' : '是' }}</span>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span='9' style="display:flex;">
                  <label>户籍地：</label>
                  <div style="width:70%;">
                    <Normap
                      :tit='debInfo.province ? (debInfo.province + debInfo.city + debInfo.area + debInfo.addr) : null'>
                    </Normap>
                  </div>
                </a-col>
                <a-col :span='7' style="display:flex;">
                  <label>常住地：</label>
                  <div style="width:70%;">
                    <Normap
                      :tit='debInfo.dwell_province ? (debInfo.dwell_province + debInfo.dwell_city + debInfo.dwell_area + debInfo.dwell_addr) : null'>
                    </Normap>
                  </div>
                </a-col>
                <a-col :span='4'>
                  <label>代偿完毕：</label>
                  <span>{{ debInfo.is_full_pay == 1 ? '不详' : (debInfo.is_full_pay == 2 ? '是' : '否') }}</span>
                </a-col>
                <a-col :span='4'>
                  <label>最后代偿时间：</label>
                  <span>{{ debInfo.last_compensation_time | yearFormat }}</span>
                </a-col>
              </a-row>
            </div>
          </div>
          <div class="card wbg">
            <div class="htit">
              <div class="h2">关联被告信息</div>
            </div>
            <div class="tableList" v-if='debInfo.other_debtor && debInfo.other_debtor.length > 0'>
              <div class="table">
                <table>
                  <thead>
                    <td width='78'>姓名</td>
                    <td width='120'>证件号码</td>
                    <td width='94'>联系方式</td>
                    <td width='40'>性别</td>
                    <td width='70'>关系</td>
                    <td width='152'>户籍地</td>
                    <td width='152'>常住地</td>
                  </thead>
                  <tbody>
                    <tr v-for='(i, index) in debInfo.other_debtor' :key='i.id'>
                      <td>{{ i.realname }}</td>
                      <td>{{ i.chinaid }}</td>
                      <td>{{ i.phone }}</td>
                      <td>{{ i.sex | tosex }}</td>
                      <td> {{ i.relation | torelation }}</td>
                      <td>
                        <Normap :tit='i.province + i.city + i.area + i.addr'></Normap>
                      </td>
                      <td>
                        <Normap
                          :tit='i.dwell_province ? (i.dwell_province + i.dwell_city + i.dwell_area + i.dwell_addr) : null'>
                        </Normap>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div> -->

          <div class="card wbg">
            <!-- <div class="htit htit1" style="margin:0;">
              <div class="h2">案件信息</div>
            </div> -->
            <CaseInformation v-if="id !== 0" class="background" :hasjdList="hasjdList" :i=i :index="index" :key="i.id">
            </CaseInformation>
            <!-- <div style="width:100%;overflow:hidden;" v-if='caselist.length > 0'>
              <div class="insetbox">
                <a-card :bordered="false" style="background:#F8F9FB;margin:0 20px;">

                  <a-row class="caseInput" style="margin-bottom:20px;">
                    <a-col :span='4'>
                      <label>{{ i.cause_type == 1 ? '诉讼' : '仲裁' }}立案代理人：</label>
                      <span>{{ i.agent }}</span>
                    </a-col>
                    <a-col :span='4'>
                      <label>开庭代理人：</label> <span v-if='i.step_dpj.length > 0'>{{ i.step_dpj[0].agent }}</span>
                    </a-col>
                    <a-col :span='5'>
                      <label>执行立案代理人：</label><span>{{ i.exec_la_agent }}</span>
                    </a-col>
                    <a-col :span='5'>
                      <label>执行代理人：</label><span>{{ i.exec_agent }}</span>
                    </a-col>
                    <a-col :span='6'>
                      <label>留置车辆：</label><span>{{ i.is_retain_car | rCar }}</span>
                    </a-col>
                  </a-row>
                  <a-row class="caseInput" style="margin-bottom:20px;">
                    <a-col :span='4' v-if='i.cause_type == 1'>
                      <label>重审案件：</label>
                      <span>{{ i.is_retrial ? (i.is_retrial == 1 ? '是' : '否') : '' }}</span>
                    </a-col>
                    <a-col :span='4' style="display: flex;" v-else>
                      <label>仲裁机构：</label>
                      <Normap :tit="i.arb_org ? i.arb_org.title : null"></Normap>
                    </a-col>
                    <a-col :span='4'>
                      <label>车辆首封：</label> <span>{{ i.is_first_ban == 0 ? '不详' : (i.is_first_ban == 1 ? '是' : '否')
                      }}</span>
                    </a-col>
                    <a-col :span='5'>
                      <label>申请拒执：</label>{{ i.is_payee_cancel | payee }}
                    </a-col>
                    <a-col :span='5'>
                      <label>支持优先受偿：</label><span>{{ i.is_first_compensation | retain }}</span>
                    </a-col>
                    <a-col :span='6' style="display: flex;">
                      <label style="white-space: nowrap;">分期履行中：</label>
                      <span v-if="i.in_loan == 1"><b>
                          <font color='#f00'>是</font>
                        </b></span>
                      <span v-else>否</span>

                    </a-col>
                  </a-row>
                  <a-row class="caseInput" style="margin-bottom:20px;" type="flex">
                    <a-col :span='4'>

                      <label>本案代偿时间：</label>
                      <span v-if='i.compensation_time'>{{ i.compensation_time | yearFormat }}</span>
                    </a-col>
                    <a-col :span='4'>

                      <label>{{ i.cause_type == 1 ? '被告' : '被申请人' }}：</label> <span>{{ '暂时' }}</span>
                    </a-col>
                    <a-col :span='5'>
                      <label>{{ i.cause_type == 1 ? '诉讼' : '仲裁' }}案号：</label> <span>{{ i.no }}</span>
                    </a-col>
                    <a-col :span='5'>
                      <label>当前进度：</label>
                      <span v-if='i.step.length > 0'>
                        {{ i.step[i.step.length - 1].title }}
                      </span>
                    </a-col>
                    <a-col :span='6' style="display: flex;">
                      <label>{{ i.cause_type == 1 ? '原告' : '申请人' }}：</label>
                      <span v-if='i.accuser' style="width:80%;">
                        <Normap :tit='i.accuser.title'>{{ i.accuser.title }}</Normap>
                      </span>
                    </a-col>
                  </a-row>
                  <a-row class="caseInput">
                    <a-col :span='4'>
                      <label>案由：</label> <span v-if='i.reason'>{{ i.reason.title }}</span>
                    </a-col>
                    <a-col :span='4'>
                      <label>业务部门：</label> <span v-if='i.team'>{{ i.team.title }}</span>
                    </a-col>
                    <a-col :span='5'>
                      <label>金融机构：</label><span v-if='i.bank'> {{ i.bank.title }}</span>
                    </a-col>
                    <a-col :span='5'>
                      <label>执行案号：</label><span v-if='i.exec_la_step.length > 0'>{{ i.exec_la_step[0].no }}</span>
                    </a-col>
                    <a-col :span='6' style="display: flex;">
                      <label style="white-space: nowrap;">管辖法院：</label>
                      <span style="width:80%;">
                        <Normap :tit='i.court | rCity'></Normap>
                      </span>
                    </a-col>
                  </a-row>
                </a-card>
              </div>
            </div> -->
            <div class="solids"></div>
            <div class="card wbg">

              <CarList v-if="id !== 0" :byTypeObject=byTypeObject :iData="i" :List='debInfo.keep' :id=id></CarList>
              <!-- <div style="width:100%;overflow:hidden;">
                <div class="insetbox" v-if='carlist.length > 0' style="padding-bottom: 20px;">
                  <div class="cselect" style="padding: 20px 20px 20px;">
                    <a-radio-group button-style="solid" v-model='carOrHouse' @change="getCarOrHouseList">
                      <a-radio :value="1">车辆信息</a-radio>
                      <a-radio :value="2" disabled>房产信息</a-radio>
                    </a-radio-group>
                  </div>
                  <div class="ntable table">
                    <table cellpadding="0" cellspacing="0">
                      <thead v-if="carOrHouse === 1">
                        <td width='40'>序号</td>
                        <td width='280'>车辆品牌</td>
                        <td width='70'>车辆颜色</td>
                        <td width='50'>排量L</td>
                        <td width='50'>排放</td>
                        <td width='140'>车架号</td>
                        <td width='80'>车辆登记人</td>
                        <td width='90'>车牌号码</td>
                        <td width='100'>初登日期</td>
                        <td width='90'>车辆估值</td>
                        <td width='90'>估值时间</td>
                      </thead>
                      <tbody v-if="carOrHouse === 1">
                        <tr v-for='(j, ind) in carlist' :key='j.id'>
                          <td>{{ ind + 1 }}</td>
                          <td>
                            <Normap :tit="j.car ? j.car.name : ''"></Normap>
                          </td>
                          <td>
                            <Normap :tit="j.color"></Normap>
                          </td>
                          <td>
                            <Normap :tit="j.car ? j.car.displacement : ''"></Normap>
                          </td>
                          <td>
                            <Normap :tit="j.car ? j.car.environmentalstandards : ''"></Normap>
                          </td>
                          <td>
                            <Normap :tit="j.car ? j.car.vin : ''"></Normap>
                          </td>
                          <td>
                            <Normap :tit="j.registrant"></Normap>
                          </td>
                          <td>
                            <Normap :tit="j.number"></Normap>
                          </td>
                          <td>
                            <Normap :tit="j.registration_time | yearFormats"></Normap>
                          </td>
                          <td>
                            <Normap :tit="j.valuation"></Normap>
                          </td>
                          <td>
                            <Normap :tit="j.valuation_time | yearFormats"></Normap>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="solids"></div>
              </div> -->
            </div>
            <HisList class="background" v-if="id !== 0" :accuser_id="i.accuser_id" :is_clear="debInfo.is_clear" :id=id>
            </HisList>
            <!-- <div class="htit" style="border:0 none;">
              <div class="h3">
                案件沟通记录
              </div>
            </div>
            <div class="twobale">
              <div class="table" v-for="(i, ind) in comList" v-if="i.list && i.list.length > 0">
                <table>
                  <thead>
                    <td width="50">序号</td>
                    <td>时间</td>
                    <td>沟通类型</td>
                  </thead>
                  <tbody>
                    <tr v-for="(j, index) in i.list">
                      <td>{{ (comment.page - 1) * 10 + (ind * 5) + (index + 1) }}</td>
                      <td>{{ j.content_time }}</td>
                      <td>{{ j.connect_type == 1 ? '裁决前沟通' : (j.connect_type == 2 ? '执行前沟通' : '执行后沟通') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> -->
            <div class="solid"></div>
            <div class="incbox">
              <!-- <div class="smlbox" v-if='credit'>
                <Count :Proposition='credit' title='主张债权及费用计算' :type='false' :payee='i.payee'
                  :seeCapital="Number(i.capital) || 0" :used_fee="i.used_fee"></Count>
              </div> -->

              <!-- <div class="smlbox" v-if='Postcredit && credit' style="padding-bottom: 20px;">
                <Count :type='true' title='确认债权及费用计算' :Proposition='Postcredit' :Credit='credit'
                  :payeeFee="i.payee_list.payeeSum" :seeCapital='Number(i.capital) || 0' :used_fee="i.used_fee"
                  :bankFee="i.bank_clear_fee" :isOther="true"></Count>
              </div> -->
            </div>

            <!-- <div class="pages" v-if="comment.total > 10">
              <a-pagination v-model="comment.page" show-quick-jumper :total="comment.total" show-less-items
                :pageSize='10' @change='(e) => { comment.page = e }' />
            </div> -->
            <div class="solids"></div>
            <Payback :loan="loan" v-if="loan.length > 0"></Payback>
            <div class="solids"></div>
            <Collection :payee="payee"></Collection>
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { shareinfo } from '@/server/debtor'
import { stepCredit, getcause, causeStep, getby_type, getAccuserAll } from '@/server/api'
import { getCarList } from '@/server/car.js'
import Proposition from "@/page/ly/stepCredit.json" //债券列表
import Count from "@/components/count"
import Payback from './payback'
import Collection from './collection'
import FileHistory from '@/page/ly/dislog/fileHistory'
import Basic from '@/page/ly/dislog/Basic'
import HisList from '@/components/HisList'
import Book from './Book'
import cmps from '@/page/ly/reg.js'
import CarList from '@/components/CarList'
import paymentCard from '@/page/ly/dislog/paymentCard'
import CaseInformation from '@/components/CaseInformation'
import { number } from 'echarts'
export default {
  components: {
    ...cmps,
    paymentCard,
    FileHistory,
    Count,
    Payback,
    Collection,
    Book,
    Basic,
    HisList,
    CarList,
    CaseInformation
  },
  data() {
    return {
      commentList: [],
      comment: {
        total: 0,
        page: 1,
        limit: 10,
      },
      payee: {}, //案款
      loan: [],
      carlist: [],
      debInfo: {},
      caselist: [],
      carOrHouse: 1,
      causeId: 0,
      loading: true, //加载
      //Edit: false,
      credit: null, //主张债权
      Postcredit: null,
      i: {},
      selectedIndex: '',
      hasjdList: [],
      index: 0,
      userLists: {},
      id: 0,
      byTypeObject: {},
      accuserList: [],
      see: false,
      OtherInfo: {},
    }
  },
  computed: {
    comList() {
      let slist = JSON.parse(JSON.stringify(this.commentList))
      let nlist = []
      if (this.comment.page == 1) {
        nlist = slist.filter((ele, index) => { return index < 10 })
      } else {
        nlist = slist.filter((ele, index) => { return index >= (this.comment.page - 1) * 10 && index < this.comment.page * 10 })
      }
      let arr = {
        0: { list: [] },
        1: { list: [] }
      }
      nlist.map((ele, index) => {
        if (index < 10) {
          arr[0].list.push(ele)
        } else {
          arr[1].list.push(ele)
        }
      })
      return arr
    },
    ...mapGetters([
      'APIKEY', //字典
      'dislog'
    ])

  },
  async created() {
    await shareinfo({ debtor_id: this.$route.params.id }).then(e => {
      this.debInfo = e.debtor
      this.caselist = e.causeList
      this.i = e.causeList[0]
      this.id = e.causeList[0].id
      this.selectedIndex = e.causeList[0].id

      this.init(e.causeList[0].id)
      stepCredit({ cause_id: e.causeList[0].id }).then(e => {
        this.credit = this.rPropo(e.list)
        this.loading = false;
      })
      getby_type({
        type: `agent${','}preservation_status${','}car_status${','}agent_model${','}cost_model`
      }).then(res => {
        this.byTypeObject = res

      })

      causeStep({ cause_id: e.causeList[0].id }).then(e => {
        const cause = this.caselist.filter(ele => { return ele.id == this.id })[0]
        this.$store.dispatch("setkey", { key: "cause", value: cause })
        this.hasjdList = e.list ? e.list : [];
      })
      getAccuserAll().then((res) => {//原告信息
        this.accuserList = res.debtor_list
      })
    })
    this.getCarOrHouseList()
  },

  filters: {
    rCity(val) {
      let cityArr = val.split(",")
      cityArr.splice(2, 1)
      return cityArr.toString()
    },
    retain(val) {
      if (val) {
        const retainList = [{
          name: "不详",
          value: 0
        },
        {
          name: "支持",
          value: 1
        },
        {
          name: "未支持",
          value: 2
        },
        {
          name: "未主张",
          value: 3
        },
        ]
        return retainList[val].name
      } else {
        return "不详"
      }
    }
  },
  methods: {
    handleUpdateUser(newData) {
      this.see = newData.see
      this.OtherInfo = newData
    },
    switchChange(e, index) {
      this.selectedIndex = e.id;
      this.i = e;
      this.causeId = e.id
      this.index = index
      this.init(e.id)
    },
    getList(id, comType) {
      let getCodeList = (v) => {     //公共 调用
        return new Promise((resolve, reject) => {
          this.$Ajax({
            url: 'cause/share/comment',
            data: {         //最小翻页数 减少页面请求数量
              connect_type: v,
              cause_id: id
            },
            type: "get",
            success: (e) => {
              resolve(e.list)
            }
          })
        })
      }
      let getAll = async () => {        //循环抛请求 
        let result = await Promise.all([1, 2, 3].map(ele => { return getCodeList(ele) }))
        return result;
      }
      getAll().then(result => {     //初始状态进行请求
        // const count=result.reduce((prev,next)=>{return prev+next.count},0)
        let list = [], sum = 0;
        result.map(ele => {
          sum += ele.length
          list = list.concat(ele)
        })
        this.comment.total = sum
        this.commentList = list
      })
    },
    visibleShow(name) {
      this.$store.dispatch("openkey", { key: name, by: true })
    },
    rPropo(Arr) {
      let newArr = []
      Object.keys(Proposition).map(item => {
        let isInclude = Arr.some(it => {
          return it.type == item
        })
        if (isInclude == false) {
          newArr.push({
            type_title: Proposition[item],
            type: item * 1,
            fee: 0
          })
        } else {
          newArr.push(Arr.filter(ele => {
            return ele.type == item
          })[0])
        }
      })
      return newArr
    },
    init(id) {
      let cause = this.caselist.find(ele => {
        return ele.id == id
      })
      this.getList(id, 1)
      this.loan = cause.loan_list
      this.payee = cause.payee_list
      const credit = cause.credit
      this.causeId = id
      // console.log(id)
      this.Postcredit = this.rPropo(credit)
    },
    async getCarOrHouseList() {
      if (this.carOrHouse === 1) {
        const res = await getCarList({
          debtor_id: this.$route.params.id
        })
        this.carlist = res.list
      }
    },

  }
}
</script>

<style lang="less">
.tab-wrap {
  .ant-tabs-bar {
    margin-left: 20px;
  }
}

.ising {
  opacity: 0.3;
}

@import './../ly/index.less';

.twobale {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;

  .table {
    width: 100%;
  }
}

.radio-inputs {
  position: relative;
  z-index: 99;
  display: flex;
  background-color: #ffffff;
  // flex-wrap: wrap;
  // border-radius: 4px;
  box-sizing: border-box;
  padding: 0 20px;
  font-size: 15px;
  height: 60px;
  align-content: center;
  gap: 15px;
  font-weight: 500;
  width: 100%;
}

.radio-inputs .radio {
  width: 8.875em;
  display: flex;
  align-items: center;
  justify-content: center;
}

.radio-inputs .radio input {
  display: none;
}

.radio-inputs .radio .name {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0.4rem 0;
  color: rgb(66, 66, 66);
  transition: all 0.15s ease-in-out;
  position: relative;
  width: 100%;
}

.radio-inputs .radio input:checked+.name {
  font-weight: bold;
}

/* Hover effect */
.radio-inputs .radio:hover .name {
  transform: translateY(-2px);
  color: #1890ff;
  font-weight: bold;
}

/* Animation */
.radio-inputs .radio input:checked+.name {
  position: relative;
  // animation: select 0.3s ease;
  color: #ffffff;
  /* 移除border-bottom */
  border-bottom: none;
  background: #1890ff;
  border-radius: 4px;
}

@keyframes select {
  0% {
    transform: scale(0.95);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

.titleButton {
  position: relative;
  padding: 0.35rem 0.55rem;
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.1), 0 18px 35px rgba(0, 0, 0, 0.15);
  background-color: #1890ff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffff;
  font-weight: bold;
  border: 3px solid #1890ff;
  overflow: hidden;
  font-size: 15px;
}

.selected {
  transition: all 0.2s ease;
  padding-block: 0.35rem;
  padding-inline: 0.55rem;
  background-color: #f7f7f8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #188fffea;
  position: relative;
  font-weight: bold;
  overflow: hidden;
  border: 1px solid #188fff6c;
}

.selected:hover {
  transform: scale(1.03);
  border: 2px solid;
}
</style>